/**
 * A record's state in color: the edge strip down a card's left side and the small square mark a
 * chip or group header carries. `record-tones.ts` holds the palette; these only draw it.
 */

import { X } from "lucide-react";

import { PANEL_COLORS } from "@/components/scorecard/utils/scorecard-styles";
import { cn } from "@/lib/utils";

import { RECORD_TONE, type RecordEdge } from "./record-tones";

/** A record's edge: a 4px color down the left, inside the card's border. */
export function RecordEdgeStrip({ tone }: { tone: RecordEdge }) {
  return (
    <span
      aria-hidden
      data-edge={tone}
      className={cn("pointer-events-none absolute inset-y-2 left-0 w-1 rounded-r-[3px]", RECORD_TONE[tone].edge)}
    />
  );
}

/** The phase or state as a small square mark: a summary chip's and a group header's. */
export function RecordMark({ tone, className }: { tone: RecordEdge; className?: string }) {
  if (tone === "cross") return <X aria-hidden className={cn("size-3 shrink-0", RECORD_TONE.cross.mark, className)} strokeWidth={3} />;
  return (
    <span
      aria-hidden
      data-mark={tone}
      className={cn("relative inline-block size-2.5 shrink-0 rounded-[3px]", RECORD_TONE[tone].mark, className)}
    >
      {tone === "ring" && <span className={cn("absolute inset-[3.5px] rounded-full", PANEL_COLORS.effort.solid)} />}
    </span>
  );
}
